import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { AnalyticsView } from "@/components/AnalyticsView";

export default function Analytics() {
  const [days, setDays] = useState("30");
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get(`/analytics/detailed?days=${days}`).then((r) => setData(r.data));
  }, [days]);

  return (
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6" data-testid="analytics-page">
      <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-[hsl(var(--brand-orange))]">Performance</div>
          <h1 className="mt-1 font-display text-3xl font-bold">Your analytics</h1>
          <p className="mt-1 text-sm text-muted-foreground">Time spent, completion rates and the chapters that need your attention.</p>
        </div>
        <div className="flex gap-2">
          <Select value={days} onValueChange={setDays}>
            <SelectTrigger className="w-36" data-testid="analytics-window-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="7" data-testid="analytics-window-7">Last 7 days</SelectItem>
              <SelectItem value="30" data-testid="analytics-window-30">Last 30 days</SelectItem>
              <SelectItem value="90" data-testid="analytics-window-90">Last 90 days</SelectItem>
            </SelectContent>
          </Select>
          <Button asChild className="bg-[hsl(var(--brand-orange))] hover:bg-[hsl(var(--brand-orange))]/90" data-testid="analytics-start-quiz-btn">
            <Link to="/quiz/new">Practice now <ArrowRight className="ml-2 h-4 w-4" /></Link>
          </Button>
        </div>
      </div>
      {data ? <AnalyticsView data={data} linkable /> : (
        <div className="grid gap-4 sm:grid-cols-3">{Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} className="h-28" />)}</div>
      )}
    </div>
  );
}
